// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-details-section--jgIpY{padding-left:16px;display:flex;flex-direction:row;align-items:center;width:300px;height:80px}.user-details-section--jgIpY .user-details-text--aOGgQ{padding-left:12px;display:flex;flex-direction:column}.user-details-section--jgIpY .user-details-text--aOGgQ>span{width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"user-details-section": "user-details-section--jgIpY",
	"user-details-text": "user-details-text--aOGgQ"
};
export default ___CSS_LOADER_EXPORT___;
